export const CART_EVENTS = {
  CLOSE_DRAWER: 'eshop:cart:close',
} as const;

export type CartEventName = (typeof CART_EVENTS)[keyof typeof CART_EVENTS];
